
export enum InvoiceDetailDataTypeCd {
	INV = 'INV',
	XML = 'XML'}

